import { render } from "./LandingView.vue?vue&type=template&id=8810d81c&scoped=true"
import script from "./LandingView.vue?vue&type=script&lang=js"
export * from "./LandingView.vue?vue&type=script&lang=js"

import "./LandingView.vue?vue&type=style&index=0&id=8810d81c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8810d81c"]])

export default __exports__